import axios from "axios";
import app from "../_app";

const filters = document.querySelector('.js-filters');

if(filters) {
    let filtersTriggers;
    let filtersFilters;
    let filtersReset;
    let filterHeaders;
    let filterMoreButtons;
    let currentFiltersHtmlResponse = null;
    let currentFiltersUrl = null;

    const collection = document.querySelector('.js-collection');
    const collectionProductsCount = collection.querySelector('.js-collection-products-count');
    const collectionProductsGrid = collection.querySelector('.js-collection-products-grid');

    const sortGhostsTrigger = collection.querySelector('.js-filters-sort-ghosts-trigger');
    const sortGhosts = [...collection.querySelectorAll('.js-filters-sort-ghost')];
    const FilterIcon = document.querySelector('.js-filter-icon');
    const priceFilterButton = document.querySelector('.js-filters-price-filter-button');

    const filtersTriggerClickHandler = () => {
        if(filters.hasAttribute('data-open')) {
            filters.removeAttribute('data-open');
            app.unlockBody();
        } else {
            app.lockBody();
            filters.setAttribute('data-open', '');
        }
    }

    const filtersChangeHandler = async (e) => {
        e.preventDefault();

        const formData = new FormData(filters);
        const params = new URLSearchParams(formData);
        currentFiltersUrl = `${filters.getAttribute('action')}${params.toString().length > 0 ? '?' : ''}${params.toString()}`;

        let response = await axios.get(currentFiltersUrl);

        if(response.status === 200) {
            updateFilters(response.data);
            updateUrl();
        }
    };

    const filtersResetHandler = async () => {
        currentFiltersUrl = filters.getAttribute('action');
        let response = await axios.get(currentFiltersUrl);

        if(response.status === 200) {
            updateFilters(response.data);
            updateUrl();

            if(app.viewport.isSmallerThan('lg')) {
                filtersTriggerClickHandler();
            }
        }
    }

    const updateFilters = (data) => {
        const parser = new DOMParser();
        currentFiltersHtmlResponse = parser.parseFromString(data, 'text/html');

        const filtersScrollPosition = filtersFilters.scrollTop;

        const currentFilterHeaderIndexes = filterHeaders.map((filterHeader, index) => {
            if(filterHeader.hasAttribute('data-open')) {
                return index;
            }
        }).filter(i => i !== undefined);

        const currentFilterMoreIndexes = filterMoreButtons.map((filterMoreButton, index) => {
            if (filterMoreButton.hasAttribute('data-open')) {
                return index;
            }
        }).filter(i => i !== undefined);

        filters.innerHTML = currentFiltersHtmlResponse.querySelector('.js-filters').innerHTML;

        if(currentFiltersHtmlResponse.querySelector('.js-filter-icon').dataset.count > 0) {
            FilterIcon.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="12" fill="#2FB152"/><path d="M9.99999 15.172L19.192 5.979L20.607 7.393L9.99999 18L3.63599 11.636L5.04999 10.222L9.99999 15.172Z" fill="white"/></svg>';
        }else {
            FilterIcon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" width="19" height="18" viewBox="0 0 19 18"><path stroke="#001E5A" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M14.5 17c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Zm-13-2h11m4 0h1m-12-4c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Zm-4-2h2m4 0h10m-6-4c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Zm-10-2h8m4 0h4"/></svg>';
        }

        initFilters();

        currentFilterHeaderIndexes.map(i => {
            filterHeaderClickHandler({currentTarget: filterHeaders[i]}, true);
        });

        currentFilterMoreIndexes.map(i => {
            filterMoreClickHandler({currentTarget: filterMoreButtons[i]}, true);
        });
        
        filtersFilters.scrollTo({top: filtersScrollPosition});

        updateProducts();
    };

    const updateProducts = () => {
        if(currentFiltersHtmlResponse !== null) {
            collection.setAttribute('data-loading', '');

            console.log(currentFiltersHtmlResponse.querySelector('.js-collection-products-count'));

            setTimeout(() => {
                collectionProductsCount.innerText = currentFiltersHtmlResponse.querySelector('.js-collection-products-count').innerText;
                collectionProductsGrid.innerHTML = currentFiltersHtmlResponse.querySelector('.js-collection-products-grid').innerHTML;
                sortGhostsTrigger.innerHTML = currentFiltersHtmlResponse.querySelector('.js-filters-sort-ghosts-trigger').innerHTML;

                setTimeout(() => {
                    collection.removeAttribute('data-loading');
                }, 200);
            }, 200);
        }
    };


    const updateUrl = () => {
        if(currentFiltersUrl !== null) {
            window.history.pushState({}, '', currentFiltersUrl);
        }
    };

    const filterHeaderClickHandler = ({currentTarget}, noTransition = false) => {
        const filterContent = currentTarget.nextElementSibling;
        let doClose = true;

        if(currentTarget === currentTarget && !currentTarget.hasAttribute('data-open')) {
            doClose = false;
        }

        if(noTransition) {
            [...currentTarget.querySelectorAll('svg path')].map(path => path.style.setProperty('transition', 'initial'));
            filterContent.style.setProperty('transition', 'initial');
        }

        if(doClose) {
            currentTarget.removeAttribute('data-open');
            filterContent.style.height = 0;
        } else {
            filterContent.style.height = `${filterContent.scrollHeight}px`;
            currentTarget.setAttribute('data-open', '');
        }

        setTimeout(() => {
            [...currentTarget.querySelectorAll('svg path')].map(path => path.style.removeProperty('transition'));
            filterContent.style.removeProperty('transition');
        }, 200);
    }

    const filterMoreClickHandler = ({ currentTarget }, noTransition = false) => {

        const filterContent = currentTarget.previousElementSibling;
        let doClose = true;


        
        if (currentTarget === currentTarget && !currentTarget.hasAttribute('data-open')) {
            doClose = false;
        }
        
        if (noTransition) {
            filterContent.style.setProperty('transition', 'initial');
        }
        
        if (doClose) {
            currentTarget.removeAttribute('data-open');
            currentTarget.innerHTML = currentTarget.getAttribute('data-more');
            filterContent.style.height = `${132}px`;
        } else {
            filterContent.style.height = `${filterContent.scrollHeight}px`;
            currentTarget.setAttribute('data-open', '');
            currentTarget.innerHTML = currentTarget.getAttribute('data-less');
        }

        setTimeout(() => {
            filterContent.style.removeProperty('transition');
        }, 200);
    }

    const sortGhostsTriggerClickHandler = () => {
        if(sortGhostsTrigger.hasAttribute('data-open')) {
            sortGhostsTrigger.removeAttribute('data-open');
            document.removeEventListener('click', sortGhostClickOutsideHandler);
        } else {
            sortGhostsTrigger.setAttribute('data-open', '');
            document.addEventListener('click', sortGhostClickOutsideHandler);
        }
    };

    const sortGhostClickOutsideHandler = ({target}) => {
        if(!sortGhostsTrigger.parentElement.contains(target)) {
            sortGhostsTriggerClickHandler();
        }
    }

    const sortGhostChangeHandler = ({currentTarget}) => {
        const field = filters.querySelector(`.js-filters-sort-field[value="${currentTarget.value}"]`);

        field.checked = true;
        filters.dispatchEvent(new Event('change'));
    }

    const initFilters = () => {
        filtersTriggers = [...document.querySelectorAll('.js-filters-trigger')];

        filtersFilters = filters.querySelector('.js-filters-inner');
        filterHeaders = [...filtersFilters.querySelectorAll('.js-filters-header')];
        filterMoreButtons = [...filtersFilters.querySelectorAll('.js-filters-more')];
        filtersReset = filters.querySelector('.js-filters-reset');

        filtersTriggers.map(filtersTrigger => filtersTrigger.addEventListener('click', filtersTriggerClickHandler));
        filterHeaders.map(filterHeader => filterHeader.addEventListener('click', filterHeaderClickHandler));
        filterMoreButtons.map(filterMoreButton => filterMoreButton.addEventListener('click', filterMoreClickHandler));

        filtersReset.addEventListener('click', filtersResetHandler);

        const priceFilter = document.querySelector('.js-filters-price');

        if(priceFilter) {
            const minInput = priceFilter.querySelector('.js-filters-price-min-input');
            const maxInput = priceFilter.querySelector('.js-filters-price-max-input');
            const range = priceFilter.querySelector('.js-filters-price-range');
            const minRange = priceFilter.querySelector('.js-filters-price-min-range');
            const maxRange = priceFilter.querySelector('.js-filters-price-max-range');
            let min = +minInput.value;
            let max = +maxInput.value;
            const calculatePriceRange = () => {
                const left = 100 / (+maxRange.max - +minRange.min) * (min - +minRange.min);
                const right = Math.abs(100 / (+maxRange.max - +minRange.min) * (max - +maxRange.max));
                range.style.setProperty('left', `${left}%`);
                range.style.setProperty('right', `${right}%`);
            }
            const priceChangeHandler = e => {
                const currentInput = e.currentTarget;
                const {type} = currentInput.dataset;
                let newMin = +(type === 'min' ? currentInput.value || min : min);
                let newMax = +(type === 'max' ? currentInput.value || max : max);

                if(type === 'min' && newMin >= newMax) {
                    newMin = newMax - 1;
                } else if(type === 'max' && newMax <= newMin) {
                    newMax = newMin + 1;
                }
                if(newMin < minRange.min) {
                    newMin = minRange.min;
                }
                if(newMax > maxRange.max) {
                    newMax = maxRange.max;
                }
                min = newMin;
                max = newMax;
                minInput.value = min;
                maxInput.value = max;
                minRange.value = min;
                maxRange.value = max;
                minInput.setAttribute('max', max);
                maxInput.setAttribute('min', min);
                calculatePriceRange();
            }
            calculatePriceRange();

            [minInput, maxInput].map(input => input.addEventListener('change', priceChangeHandler));
            [minRange, maxRange].map(input => input.addEventListener('input', priceChangeHandler));
        }
    }

    initFilters();
    filters.addEventListener('change', filtersChangeHandler);
    filterHeaders.map(filterHeader => filterHeaderClickHandler({currentTarget: filterHeader}, true));
    filterMoreButtons.map(filterMoreButton => filterMoreClickHandler({ currentTarget: filterMoreButton }, true));
    
    if (priceFilterButton) {
        priceFilterButton.addEventListener('click', filtersChangeHandler);
    }
    
    if(sortGhostsTrigger) {
        sortGhostsTrigger.addEventListener('click', sortGhostsTriggerClickHandler);
    }
    sortGhosts.map(sortGhost => sortGhost.addEventListener('change', sortGhostChangeHandler));
}
